import { Pipe, PipeTransform } from '@angular/core';
/**
 * Transforms the numeric ID input into a reflist entry
 */
@Pipe({ name: 'rdReflist' })
export class RdReflistPipe implements PipeTransform {
  /**
   * Transforms the numeric ID input into a reflist entry
   * @param input Input value (numeric). It should match a reflist entry's oid value
   * @param reflist Reflist entries
   */
  public transform(input: any, reflist: any[]): string {
    if (!reflist) {
      return '';
    }
    const result = reflist.filter((element) => {
      return element.oid == input;
    });
    if (result?.length) {
      return result[0].description;
    }
    return '';
  }
}
